import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { apiUrl, formatPrice } from '../shop';
const emptyForm = () => ({
  name: '',
  description: '',
  price: '',
  image_url: ''
});

/** Plain page where a vendor adds, edits and deletes their products and sees orders for them. */
export default class VendorProductsPage extends Page {
  loading = true;
  saving = false;
  products = [];
  orders = [];
  form = emptyForm();
  editingId = null;
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('canSellProducts')) {
      m.route.set(app.route('index'));
      return;
    }
    app.setTitle('My products');
    this.load();
  }
  load() {
    Promise.all([app.request({
      method: 'GET',
      url: apiUrl('/shop/products?mine=1')
    }), app.request({
      method: 'GET',
      url: apiUrl('/shop/vendor-orders')
    })]).then(([products, orders]) => {
      this.products = products;
      this.orders = orders;
    }).catch(() => {}).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    return m("div", {
      className: "ShopPage container"
    }, m("h2", null, "My products"), this.formView(), m("h3", null, "Your products"), this.loading ? m(LoadingIndicator, null) : this.productsTable(), m("h3", null, "Orders for your products"), this.loading ? m(LoadingIndicator, null) : this.ordersTable());
  }
  formView() {
    const input = (key, label, attrs = {}) => m("div", {
      className: "Form-group"
    }, m("label", null, label), m("input", Object.assign({
      className: "FormControl",
      value: this.form[key],
      oninput: e => this.form[key] = e.target.value
    }, attrs)));
    return m("form", {
      className: "ShopForm",
      onsubmit: this.save.bind(this)
    }, m("h3", null, this.editingId ? 'Edit product' : 'Add a product'), input('name', 'Name', {
      required: true,
      maxlength: 255
    }), input('price', 'Price', {
      required: true,
      type: 'number',
      min: 0,
      step: '0.01'
    }), input('image_url', 'Image URL (optional)', {
      type: 'url',
      placeholder: 'https://...'
    }), m("div", {
      className: "Form-group"
    }, m("label", null, "Description (optional)"), m("textarea", {
      className: "FormControl",
      rows: 3,
      maxlength: 5000,
      value: this.form.description,
      oninput: e => this.form.description = e.target.value
    })), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.saving
    }, this.editingId ? 'Save changes' : 'Add product'), ' ', this.editingId && m(Button, {
      className: "Button",
      onclick: () => this.resetForm()
    }, "Cancel"));
  }
  productsTable() {
    if (!this.products.length) return m("p", null, "No products yet.");
    return m("table", null, m("thead", null, m("tr", null, m("th", null, "Name"), m("th", null, "Price"), m("th", null, "Code to paste in a post"), m("th", null))), m("tbody", null, this.products.map(product => m("tr", null, m("td", null, product.name), m("td", null, formatPrice(product.price)), m("td", null, m("code", null, "[product=", product.id, "][/product]")), m("td", null, m(Button, {
      className: "Button Button--link",
      onclick: () => this.edit(product)
    }, "Edit"), m(Button, {
      className: "Button Button--link",
      onclick: () => this.delete(product)
    }, "Delete"))))));
  }
  ordersTable() {
    if (!this.orders.length) return m("p", null, "No orders yet.");
    return m("table", null, m("thead", null, m("tr", null, m("th", null, "Order"), m("th", null, "Date"), m("th", null, "Buyer"), m("th", null, "Ship to"), m("th", null, "Items"))), m("tbody", null, this.orders.map(order => m("tr", null, m("td", null, "#", order.id), m("td", null, dayjs(order.created_at).format('YYYY-MM-DD')), m("td", null, order.buyer), m("td", null, order.shipping_name, m("br", null), order.shipping_address), m("td", null, order.items.map(item => m("div", null, item.quantity, " \xD7 ", item.product_name, " (", formatPrice(item.price), ")")))))));
  }
  edit(product) {
    this.editingId = product.id;
    this.form = {
      name: product.name,
      description: product.description ?? '',
      price: String(product.price),
      image_url: product.image_url ?? ''
    };
    window.scrollTo(0, 0);
  }
  resetForm() {
    this.editingId = null;
    this.form = emptyForm();
  }
  save(e) {
    e.preventDefault();
    this.saving = true;
    const editingId = this.editingId;
    app.request({
      method: editingId ? 'PATCH' : 'POST',
      url: apiUrl(editingId ? `/shop/products/${editingId}` : '/shop/products'),
      body: this.form
    }).then(saved => {
      this.products = editingId ? this.products.map(p => p.id === saved.id ? saved : p) : [saved, ...this.products];
      this.resetForm();
    }).catch(() => {}) // the error alert is shown by app.request
    .finally(() => {
      this.saving = false;
      m.redraw();
    });
  }
  delete(product) {
    if (!confirm(`Delete "${product.name}"? Posts that show it will say it is no longer available.`)) return;
    app.request({
      method: 'DELETE',
      url: apiUrl(`/shop/products/${product.id}`)
    }).then(() => {
      this.products = this.products.filter(p => p.id !== product.id);
      if (this.editingId === product.id) this.resetForm();
    }).catch(() => {}).finally(() => m.redraw());
  }
}
flarum.reg.add('abdulrehman-shop', 'forum/components/VendorProductsPage', VendorProductsPage);